import ColumnPage from './ColumnPage';

export default function Borderlands() {
  return (
    <ColumnPage
      column="borderlands"
      title="EDGE OF THE BORDERLANDS"
      description="Share travel experiences and practical adventure insights. Stories of journeys, what you brought, how you navigated spaces, and lessons learned."
    />
  );
}
